<!-- "Create Shorts from the script" under the Script of the video dialog (#shortSlot, in ScriptPicker.vue): active only
     for a Long Form video whose script has at least SH_MIN words; otherwise a faded, dashed box with the reason on hover
     and, on tap (phone), under it (#shortWhy). Opens the suggestions window (ShortsDialog.vue). Logic in
     src/features/shorts.ts. -->
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from '../../composables/useI18n'
import { useProfileData } from '../../composables/useProfileData'
import { useDataStore } from '../../stores/data'
import { useDialogsStore } from '../../stores/dialogs'
import { useVideoStore } from '../../stores/video'
import { shScriptHtml, shortWhy } from '../../features/shorts'

const { t } = useI18n()
const data = useProfileData()
const video = useVideoStore()
const dialogs = useDialogsStore()

const why = computed(() => (video.form ? shortWhy(video.kind(), shScriptHtml(data.value, video.form.scriptId)) : ''))
/** The reason shown under the box (tap); closed again when the type or the script changes, like before */
const open = ref(false)
watch([() => video.kind(), () => video.form?.scriptId, () => video.scriptsTick], () => { open.value = false })

function openShorts() {
  if (!video.form || shScriptHtml(useDataStore().getData(), video.form.scriptId) == null) return
  dialogs.show('shorts', {})
}
</script>

<template>
  <div id="shortSlot" class="mt-3">
    <button v-if="!why" type="button" class="w-full flex items-center justify-center gap-2 border border-brand/60 bg-brand/10 hover:bg-brand/20 text-brand py-2.5 rounded-lg font-bold text-sm transition" @click="openShorts"><i class="fas fa-scissors"></i>{{ t('Create Shorts from the script') }}</button>
    <template v-else>
      <div role="button" aria-disabled="true" tabindex="0" :title="why" class="w-full flex items-center justify-center gap-2 border-2 border-dashed border-gray-600 text-gray-500 opacity-50 py-2.5 rounded-lg font-bold text-sm cursor-not-allowed select-none" @click="open = !open"><i class="fas fa-scissors"></i>{{ t('Create Shorts from the script') }}</div>
      <p id="shortWhy" :class="[{ hidden: !open }, 'mt-1.5 text-[11px] text-gray-500']"><i class="fas fa-circle-info mr-1"></i>{{ why }}</p>
    </template>
  </div>
</template>
